
<template>
  <section id="sea" data-section="Intro" data-section-fr="Intro">
    <canvas class="displacement"></canvas>

    <div
      class="scene"
      data-bg
      data-tablet="/images/sea-tablet.jpg"
      data-mobile="/images/sea-mobile.jpg">
      <div class="scene__item scene__item--medusas">
        <img src="/images/medusas-4-p2.png" alt="medusas 1">
      </div>
      <div class="scene__item scene__item--medusas">
        <img src="/images/medusas-4-p2.png" alt="medusas 2">
      </div>
      <div class="scene__item scene__item--medusas">
        <img src="/images/medusas-4-p2.png" alt="medusas 3">
      </div>
    </div>

    <div class="wrapper">
      <div class="row row--h-center">
        <div class="col-8 col-tabletW-12 text--center">
          <h1 class="title title--big anim--split ft-68" data-split="chars">
            {{ $t('seaTitle') }}
          </h1>

<!--          <p class="text&#45;&#45;big anim&#45;&#45;split ff-dr ft-35"-->
<!--            data-split="lines">-->
<!--            New Today, New Life-->
<!--          </p>-->
        </div>
      </div>
    </div>

    <SeaDive ref="dive" />
  </section>
</template>

<script>
import SeaDive from './SeaDive.vue'
import SceneSea from '@/oceanSchool/sceneSea.js'

export default {
  components: {
    SeaDive
  },

  beforeDestroy () {
    this.sceneSea && this.sceneSea.dispose()
    this.sceneSea = null
  },

  methods: {
    start () {
      this.sceneSea = new SceneSea(this.$el)
      setTimeout(() => {
        // console.log('sea call dive.start')
        this.$refs.dive.start()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
#sea {
  background: #05111f;
  min-height: 100vh;
  height: 100vh;
  backface-visibility: hidden
}

.mobile #sea,.tablet #sea {
  height: auto!important
}

#sea .wrapper {
  // top: 35vh;
  top: 40vh;
  transform: translateY(-55%);
  color: #fff;
  text-align: center;

  .title {
    line-height: 120px;
    margin-top: 60px;
    font-size: 45px;
  }
}

#sea .scene {
  z-index: 1020;
  backface-visibility: hidden
}

@media (max-width: 1024px) {
  #sea .scene__item {
      display:none
  }
  #sea .scene {
    background-image: url(/images/sea-tablet.jpg);
  }
}
@media (max-width: 768px) {
  #sea .wrapper .title {
    font-size: 9.8vw;
    line-height: 1.02;
    margin-bottom: 24px;
  }
  #sea .wrapper .text--big {
    font-size: 5.7vw;
  }
}
@media (max-width: 640px) {
  #sea .scene {
    background-image: url(/images/sea-mobile.jpg);
  }
}

#sea .scene__item--medusas {
  position: absolute;
  width: auto
}

#sea .scene__item--medusas:nth-child(1) {
  left: 5%;
  bottom: 0;
  transform: rotate(20deg) scale(.75);
  opacity: .75
}

#sea .scene__item--medusas:nth-child(2) {
  left: 53%;
  bottom: 10px
}

#sea .scene__item--medusas:nth-child(3) {
  left: 85%;
  bottom: 20px;
  transform: rotate(-20deg) scale(.6);
  opacity: .4
}
</style>
